import { app } from './nl/app'
import {errorboundary} from './nl/errorBoundary'

export const nl = {
  app,
  errorboundary,
}
